import { Card, Checkbox, Col, Form, Input, Row, Typography } from "antd";
import React, { useState } from "react";
const { Title } = Typography;

const Authorization = ({ getChildData, patientDetailsFMLA }) => {
    const [signatureActive, setSignatureActive] = useState(false)
    const callparent = (e, name) => {
        getChildData(e, name);
    };

    return (
        <Card
            styles={{ body: { padding: 0 }, header: { marginBottom: 20 } }}
            bordered={false}
            size="0"
            title={
                <Title
                    className="font-semibold"
                    style={{ marginBottom: "0" }}
                    level={4}
                >
                    Authorization
                </Title>
            }
        >
            <Row gutter={[0, 10]} className="px-1 md:px-6">
                <Col span={24}>
                    <Form.Item
                        name="Authorization1"
                        valuePropName="checked"
                        onChange={(e) => callparent(e.target.checked, "Authorization1")}
                        checked={patientDetailsFMLA.Authorization1}
                        className="checkbox-align-top"
                        rules={[
                            {
                                validator: (_, value) =>
                                    value
                                        ? Promise.resolve()
                                        : Promise.reject(
                                            new Error("Please accept the authorization.")
                                        ),
                            },
                        ]}
                    >
                        <Checkbox className="font-medium">
                            I understand that I (or patient, if requested from third-party source) may revoke this authorization (or an attached authorization) in writing at any time exceptto the
                            extent that action has been taken in reliance upon this authorization. (45 CFR § 164.508(c)(2)(i))
                        </Checkbox>
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        name="Authorization2"
                        valuePropName="checked"
                        checked={patientDetailsFMLA.Authorization2}
                        onChange={(e) => callparent(e.target.checked, "Authorization2")}
                        className="checkbox-align-top"
                        rules={[
                            {
                                validator: (_, value) =>
                                    value
                                        ? Promise.resolve()
                                        : Promise.reject(
                                            new Error("Please accept the authorization.")
                                        ),
                            },
                        ]}
                    >
                        <Checkbox className="font-medium">
                            I understand that treatment or payment cannot be conditioned on my signing this authorization (or an attached authorization), except in certain circumstances such as
                            for participation in research programs, or authorization of the release of testing results for pre-employment purposes. (45 CFR § 164.508(c)(2)(i))
                        </Checkbox>
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        name="Authorization3"
                        valuePropName="checked"
                        checked={patientDetailsFMLA.Authorization3}
                        onChange={(e) => callparent(e.target.checked, "Authorization3")}
                        className="checkbox-align-top"
                        rules={[
                            {
                                validator: (_, value) =>
                                    value
                                        ? Promise.resolve()
                                        : Promise.reject(
                                            new Error("Please accept the authorization.")
                                        ),
                            },
                        ]}
                    >
                        <Checkbox className="font-medium">
                            I understand that my (or the patient’s, if requested from third-party source) records are confidential and cannot be disclosed without written authorization except when
                            otherwise permitted by law. Information used or disclosed pursuant to this authorization (or an attached authorization) may be subject to re-disclosure by the recipient
                            and no longer protected. I understand that the specified information to be released may include, but is not limited to history, diagnosis, and/or treatment of drug or
                            alcohol abuse, mental illness, or communicable disease, including Human Immunodeficiency Virus (HIV), Acquired Immune Deficiency Syndrome (AIDS), and genetic
                            documentation as related to Genetic Information Nondiscrimination Act (GINA). (45 CFR §164.508(c)(2)(i))                        </Checkbox>
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        wrapperCol={{ lg: 12 }}
                        onChange={(e) => callparent(e.target.value, "Authorizationsignature")}
                        name="Authorizationsignature"
                        label="This authorization will expire One Hundred Eighty (180) days from the date of signature unless revoked by authorized party prior to that time. If a third-party request, 
expiration will also expire One Hundred Eighty (180) days from the date of signature unless explicitly written in an attached authorization."
                        className={`signature ${patientDetailsFMLA.Authorizationsignature != "" || signatureActive ? "" : "auth-watermark"}`}
                        rules={[{ required: true, message: "Please enter signature." }]}
                    >
                        <Input maxLength={100} onBlur={() => { setSignatureActive(false) }} onFocus={() => { setSignatureActive(true) }} />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        name="Authorization4"
                        checked={patientDetailsFMLA.Authorization4}
                        valuePropName="checked"
                        onChange={(e) => callparent(e.target.checked, "Authorization4")}
                        className="checkbox-align-top"
                        rules={[
                            {
                                validator: (_, value) =>
                                    value
                                        ? Promise.resolve()
                                        : Promise.reject(
                                            new Error("Please accept the term and condition.")
                                        ),
                            },
                        ]}
                    >
                        <Checkbox className="font-medium">
                            I understand that checking this box constitutes a legal signature confirming that I acknowledge and agree to the above Terms of Use.                        </Checkbox>
                    </Form.Item>
                </Col>
            </Row>
        </Card>
    );
};
export default Authorization;
